import formatDateProperties from './formatDateProperties';
export default function formatForApiCall(item: any): any {
    // return item;
    return formatDateProperties(item);
}
